import { Badge } from "@/components/ui/badge";
import type { DispatchStatus, OrderStatus } from "@/types";

type Variant = "default" | "secondary" | "destructive" | "outline" | "success" | "warning" | "blue";

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  OPEN: "Open",
  PARTIAL: "Partly dispatched",
  DISPATCHED: "Fully dispatched",
  CANCELLED: "Cancelled",
};
const ORDER_VARIANTS: Record<OrderStatus, Variant> = { OPEN: "secondary", PARTIAL: "warning", DISPATCHED: "success", CANCELLED: "outline" };

export const DISPATCH_STATUS_LABELS: Record<DispatchStatus, string> = { DISPATCHED: "Handed over", IN_TRANSIT: "In transit", DELIVERED: "Delivered", CANCELLED: "Cancelled" };
const DISPATCH_VARIANTS: Record<DispatchStatus, Variant> = { DISPATCHED: "secondary", IN_TRANSIT: "blue", DELIVERED: "success", CANCELLED: "outline" };

export function OrderStatusBadge({ status }: { status: OrderStatus }) {
  return <Badge variant={ORDER_VARIANTS[status] || "outline"}>{ORDER_STATUS_LABELS[status] || status}</Badge>;
}

export function DispatchStatusBadge({ status }: { status: DispatchStatus }) {
  return <Badge variant={DISPATCH_VARIANTS[status] || "outline"}>{DISPATCH_STATUS_LABELS[status] || status}</Badge>;
}
